var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.vaultItem)?_c('data-visualizer',{attrs:{"item":_vm.vaultItem}}):_c('spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }